const type1desc = (
  <p>
    คนลักษณ์ 1 มีความใส่ใจกับเรื่องของ “ความถูกต้อง” “ความเป็นมาตรฐาน”
    มาตั้งแต่เด็กๆ ดังนั้นในใจของคนลักษณ์ 1
    จะมีภาพของความสมบูรณ์แบบของเรื่องราวต่างๆ ทั้งการทำงาน การใช้ชีวิต
    สิ่งแวดล้อม สิ่งของต่างๆ อยู่ตลอดเวลา
    จึงปรากฎออกมาเป็นบุคลิกภาพหรือพฤติกรรมที่มักจะมองเห็นจุดบกพร่องของสิ่งต่างๆ
    หรือเรื่องราวต่างๆ ง่ายและเร็วกว่าคนอื่นๆ
  </p>
);

const type2desc = (
  <p>
    มีความต้องการพื้นฐานคือการเอาใจใส่และดูแลผู้อื่น
    เป็นคนที่อุทิศตนเพื่อสนองความต้องการของคนอื่น
    และอยากเป็นคนที่ได้รับความรักความสำคัญ มักจะมีเซนส์ รู้ว่าคนอื่นชอบอะไร
    เพื่อที่จะได้ตอบสนองความรู้สึกคนอื่นได้ เข้าอกเข้าใจคนอื่น
    จนบางครั้งละเลยความรู้สึกและความต้องการของตัวเอง
    ไม่ชอบทำให้คนอื่นผิดหวังหรือเสียใจ <br />
    แคร์คนรอบข้างเป็นส่วนใหญ่พออยู่ในสภาวะกดดันมีความรับผิดชอบเพิ่มขึ้น
    รวมถึงภาวะการเป็นผู้นำ คนลักษณ์นี้จะไวต่อความรู้สึกมาก
    และตอบสนองโดยสัญชาตญาณ ห่วงภาพลักษณ์ของตัวเอง
    สามารถพัฒนาตนเองได้ดีเมื่อได้รับคำชม (ต่อเมื่อเป็นคำชมจากใจจริง)
    แต่ก็จะเขินๆหน่อย หัวใจเต้นแรง บางครั้งจะรู้สึกน้อยใจง่าย
    ถ้ารู้สึกว่าตัวเองไม่สำคัญ
  </p>
);

const type3desc = (
  <p>
    บุคลิกภาพที่เรามักจะพบเห็นในคนลักษณ์ 3 ก็คือ กระตือรือร้น ทำงานหนัก
    และจัดการงานหลายอย่างได้พร้อมกัน แต่งตัวดีเหมาะสมกับกาละเทศะ และดูดีเสมอ
    คนลักษณ์ 3 เป็นลักษณ์แกนกลางของศูนย์ใจ ที่สัมพันธ์กับเรื่องของภาพลักษณ์
    (Image) มาก ดังนั้นพลังชีวิตที่มีมากที่สุดของคนลักษณ์สาม คือพลังใจนั้น
    จะทุ่มเทและขับเคลื่อนออกมาอย่างมากในเรื่องของการสวมบทบาทที่ตนเองคิดว่าตนเองเป็นเพื่อบรรลุเป้าหมายที่ตั้งไว้
    ซึ่งส่วนมากจะเป็นเรื่องการทำงาน ใส่ใจกับเป้าหมาย
    เมื่อตนเองกำหนดเป้าหมายไว้แล้วก็จะทำทุกวิถีทาง
    และมุ่งมั่นอย่างมากเพื่อบรรลุเป้าหมายดังกล่าว ดังนั้น
    เมื่อลักษณ์ตั้งเป้าว่าจะเป็นนักธุรกิจที่ประสบความสำเร็จ
    คนสามก็สวมบทบาทนักธุรกิจด้านนั้นตามภาพลักษณ์ที่ตนเองกำหนดไว้ ดังนั้น
    เราจะพบผู้นำองค์กรที่เป็นลักษณ์สามได้ทุกประเภทขององค์กร ในทุกกลุ่มสังคม
  </p>
);

const type4desc = (
  <p>
    ลักษณ์ 4 เป็นคนโศกซึ้ง มีความเป็นศิลปิน ช่างคิด ช่างจินตนาการ
    มักความคิดสร้างสรรค์สูง และ unique ไม่เหมือนใคร เนื่องจากเป็นกลุ่มคนศูนย์ใจ
    จะเห็นได้ชัดว่าคนลักษณ์นี้จะใช้ใจเป็นหลัก และจมดิ่งอยู่กับอารมณ์
    มักใช้อารมณ์เป็นตัวสินใจ จึงทำให้ดูเเป็นคนเจ้าอารมณ์ไม่ค่อยมีเหตุผล
    คนลักษณ์นี้ให้ความสำคัญกับความสัมพันธ์เป็นอย่างมาก
    พวกเขาสามารถสัมผัส/เข้าถึงอารมณ์-ความรู้สึกของคนรอบตัวได้ง่าย
    และแคร์ความรู้สึกของผู้อื่นมาก
    คำพูดของคนใกล้ชิดจึงมีผลต่อความรู้สึกเป็นอย่างสูง
    อาจเสียใจอย่างรุนแรงหากเกิดความเข้าใจผิดขึ้น
    คนลักษณ์นี้หากรักใครแล้วก็อาจหลงเชื่อได้โดยไม่มีเหตุผล เพราะเชื่อใจไปแล้ว
    เมื่อผิดหวังจะโศกเศร้ามากและนาน และหากทะเลาะกับใครขึ้นมาก็จะรุนแรงมากเช่นกัน
  </p>
);

const type5desc = (
  <p>
    ลักษณ์ 5 มักจะคุ้นเคยกับด้านที่ใช้ลางสังหรณ์และความคิดของเขาเป็นอย่างดี
    พวกเขาอยากจะเป็นเลิศในด้านต่างๆ อยากจะรู้ว่าทุกอย่างทำงานยังไง
    พยายามตั้งคำถาม และดำดิ่งเข้าไปในทฤษฎีและข้อมูลต่างๆ <br />
    พวกเขาจะรู้สึกอึดอัดเมื่ออยู่ท่ามกลางคนรอบข้างเป็นระยะเวลานานเกินไป
    และต้องการพื้นที่ส่วนตัวเพื่อที่จะเยียวยาตัวเองจากความรู้สึกนั้น
    พวกเขาอยากจะรู้ความจริงเกี่ยวกับเรื่องต่างๆ
    พวกเขาจึงใช้เวลาส่วนใหญ่ไปกับการครุ่นคิด สำรวจ สังเคราะห์ข้อมูลความรู้
    พวกเขาต้องการที่จะเป็นคนที่มีความคิดสร้างสรรค์และมุมมองแปลกใหม่ให้กับโลกใบนี้
    อย่างไรก็ตาม เนื่องจากลักษณ์ 5 มักจะไม่ค่อยได้มีโอกาสมาสัมผัสโลกภายนอก
    พวกเขาอาจจะรับรู้ข้อมูลเพียงด้านเดียวและหลงลืมความเป็นจริงของโลกได้
  </p>
);

const type6desc = (
  <p>
    สำหรับคนลักษณ์ 6 นั้นเป็นคนศูนย์หัว ซึ่งเน้นการคิดวิเคราะห์ จดจำ คาดการณ์
    และวางแผน โดยปกติแล้วจะเป็นคนลักษณ์ 6 ต้องการความมั่นคงปลอดภัย
    เนื่องจากมีความกลัวเป็นพื้นฐาน ดังนั้นคนลักษณ์ 6 จะตั้งคำถามต่อสิ่งต่าง ๆ
    ที่เข้ามาทุกเรื่อง และเพื่อปกป้องตัวเองออกจากสภาวะที่ไม่มั่นคง <br />
    คนลักษณ์ 6 จะมีความจงรักภักดีต่อผู้นำ หรือองค์กรณ์ที่สามารถปกป้องตนเองได้
    เพราะต้องการที่พึ่งและคนที่คอยนำทางให้ โดยมีลักษณะเด่นคือจงรักภักดี
    ทำงานหนัก พึ่งพาได้ ระมัดระวัง และเป็นนักคิดวิเคราะห์
    ชอบเป็นผู้ตามมากว่าเป็นผู้นำ มีจิณตนาการสูง แต่ชอบจินตนาการสิ่งต่าง ๆ
    ไปในทางลบ โดยนึกถึงเหตุการณ์ที่แย่ที่สุดที่จะเกิดขึ้นได้
    และหาทางป้องกันและคอยหาช่องว่างที่สามารถป้องกันได้ <br />
    โดยส่วนใหญ่นั้นมักไม่ไว้ใจผู้มีอำนาจ และมักจะช่วยเหลือผู้ที่เสียเปรียบ
    เป็นนักแก้ปัญหาที่ดีเพราะจะคิดวิเคราะห์ปัญหาและหาทางแก้ได้
    และชอบวางแผนเพื่อให้เห็นภาพสิ่งที่จะเกิดขึ้น
    มักจะกลัวความเปลี่ยนแปลงเพราะเมื่อรู้สึกมั่นคงกับอะไรแล้ว ก็ยากที่จะเปลี่ยน
    มักจะตั้งคำถามกับทุกอย่างเพื่อความรู้สึกมั่นคง
    เมื่อศรัทธาอะไรแล้วก็มักจะทำเพื่อสิ่งนั้นอย่างจริงจัง
  </p>
);

const type7desc = (
  <p>
    คนลักษณ์ 7 ถูกขับเคลื่อนด้วยความสุข ความสนุกสนาน
    เพราะงั้นแล้วตามความรู้สึกของคนลักษณ์ 7
    โลกนี้ก็เปรียบเหมือนกับสนามเด็กเล่นอันกว้างใหญ่
    ที่มีของเล่นมากมายขอให้เขาไปเลือกทดลองเล่นอยู่เสมอ แต่เมื่อคนลักษณ์ 7
    เริ่มมีเรื่องให้ทุกข์ใจหรือเจ็บปวด เขาก็จะหนีหายไปเลย
    ถ้าเขาถูกผลักดันให้เขาหาความเจ็บปวดเขาก็จะสามารถหาเหตุผลต่าง ๆ
    นานามาทำให้มันหายไปให้ได้ เขาจะมองหาข้อดีหรืออะไรก็ตามที่ยังเหลืออยู่ เช่น
    ถ้าหากมีน้ำตั้งอยู่บนโต๊ะเหลืออยู่ครึ่งแก้ว
    บางคนอาจคิดว่ามันมีแค่ครึ่งแก้วเอง แต่สำหรับ 7
    เขาจะคิดว่ามันเหลืออยู่ตั้งครึ่งแก้ว <br />
    แม้คนลักษณ์ 7 จะมีความสุขเมื่ออยู่กับเพื่อนฝูง
    แต่เมื่อเขาเผชิญกับปัญหาของคนอื่น เขาจะรีบหาวิธีจัดการกับมันให้เร็วที่สุด
    ชีวิตของเขาจะได้กลับมามีความสุขและสนุกเหมือนเดิม <br />
    และสุดท้าย คนลักษณ์ 7 มองว่าชีวิตของตัวเองมีโอกาสมากมายให้เลือก
    และเมื่อเขาลงมือทำอะไรสักอย่างด้วความตั้งใจเป็นอย่างมากแล้วเขาจะสามารถทำมันออกมาได้ดีอยู่เสมอ
  </p>
);

const type8desc = (
  <p>
    ผู้นำลักษณ์ 8 มีชื่อเรียกว่า เจ้านาย หรือ ผู้ปกป้อง
    เป็นคนที่มีพลังมากที่สุดใน 9 ลักษณ์
    และคนอื่นก็มักจะสังเกตเห็นพลังดังกล่าวได้ค่อนข้างง่ายจากบุคลิกภาพที่ปรากฎ
    เช่น เสียงดัง มีแรงเยอะแม้จะเป็นผู้หญิงตัวเล็กๆ
    ทำงานได้ทั้งวันไม่รู้จักเหน็ดเหนื่อย เป็นคนรักษาสิทธิ์
    คนทั่วไปอาจจะมองว่าคนแปดเป็นคนค่อนข้างก้าวร้าว <br />
    เรามักพบว่า ปัจจัยสำเร็จของคนแปด ที่ทำให้สามารถขึ้นมาสู่การเป็นผู้บริหาร
    หรือผู้นำ (ด้วยความเป็นลักษณ์ 8 ไม่ใช่ด้วยปัจจัยอื่น)
    คือเป็นคนที่ชอบงานท้าทาย งานยากๆ เพราะคนแปดสามารถจัดการเรื่องยากๆ
    ให้สำเร็จได้ ด้วยการตัดสินใจที่เด็ดขาด และชัดเจน กระฉับกระเฉง
    เชื่อมั่นในตนเองสูง สไตล์การทำงานของคนแปดที่มุ่งมั่น และควบคุม จัดการเก่ง
    จึงเป็นที่ชื่นชอบและได้รับการสนับสนุนขึ้นเป็นหัวหน้างาน
    เป็นผู้บริหารตามลำดับ สมกับชื่อที่ในหลายตำรานพลักษณ์เรียกคนลักษณ์แปดว่า
    “เจ้านาย” และอีกบุคลิกหนึ่งของคนแปดคือ การปกป้องคนที่อ่อนแอกว่า
    การเข้มข้นในการเรียกร้องสิทธิ์ให้ทั้งกับผู้อื่นและตนเอง
    จึงเป็นที่รักของลูกน้องและทีมงาน
    เป็นอีกหนึ่งปัจจัยให้คนแปดก้าวขึ้นเป็นผู้บริหารในหลายๆ องค์กร
  </p>
);

const type9desc = (
  <p>
    คนลักษณ์ 9 คนลักษณ์นี้เป็นคนใฝ่สันติ ไม่ชอบเห็นคนขัดแย้งหรือเข้ากันไม่ได้
    เป็นคนไม่รีบร้อน ไม่ชอบการแข่งขัน ชอบทำอะไรสบายๆ ชอบชีวิตที่ราบรื่นกลมกลืน
    สงบ สะดวกสบายจึงมีความเห็นคล้อยตามไปกับแผนการของทุกๆ คน
    เพื่อไม่ให้เกิดความขัดแย้ง
    มักวุ่นอยู่กับเรื่องที่ไม่สำคัญจนลืมเป้าหมายที่แท้จริงของตน
    มีงานอดิเรกมากมาย ตัดสินใจอะไรยาก รอจนเหมือนผัดวันประกันพรุ่ง ตัดสินใจช้า
    มักจะทำในนาทีสุดท้าย เพราะไม่ค่อยแน่ใจอะไรง่ายๆ เป็นคนลังเล
    ต้องการข้อมูลครบทุกด้านก่อนตัดสินใจ ไม่กล้าปฏิเสธ มีความรู้สึกสองจิตสองใจ
    เพราะมองเห็นมุมต่าง ๆ ทุกมุมจนตัดสินใจยาก และมักไม่แน่ใจว่าตนเองต้องการอะไร
    เป็นที่รักของเพื่อน ๆ เข้าใจผู้อื่นได้ดี ใจกว้าง
    มีความสามารถในการประสานคนกลุ่มต่าง ๆ ประณีประนอม มองปัญหาได้รอบด้าน
    อย่างไรก็ตามในภาวะที่ถูกกดดัน คนลักษณ์นี้ก็อาจกลายจะเป็นคนดื้อเงียบ
  </p>
);

export const types = {
  type1: {
    type: "Type1",
    title: "คนเนี้ยบ (The Perfectionist)",
    description: type1desc,
    strength: {
      s1: "มีวินัยในตัวเองสูง ",
      s2: "มีอุดมคติ",
      s3: "รักในความถูกต้อง",
      s4: "ทำตามกฎระเบียบเป็นที่ตั้ง",
      s5: "ปรับปรุง และพัฒนาคุณภาพอยู่ตลอดเวลา",
    },
    weakness: {
      w1: "ไม่ยืดหยุ่น",
      w2: "ให้ความสำคัญกับรายละเอียดมากเกินไป",
      w3: "เคร่งเครียด ยึดมั่นกับกฎเกณฑ์ และมาตรฐานสูง  ",
      w4: "ช่างตำหนิ วิพากษ์วิจารณ์",
      w5: "ปรับตัวยากกับบางสถานการณ์ที่ควบคุมไม่ได้",
    },
    handle: {
      h1: "ต้องการให้เพื่อนคบหาด้วยความกระตือรือร้น เพราะจะเป็นการแสดงว่าอีกฝ่ายมีส่วยร่วมในมิตรภาพอย่างเท่าเทียม",
      h2: "จะมีความหมายกับคนลักษณ์ 1 อย่างมากถ้ามีใครบอกว่าเขามีคุณค่าอน่างที่เขาเป็น และเข้าเป็นที่ต้องการสำหรับเพื่อนๆ",
      h3: "ต้องการคนที่รับฟังได้อย่างไว้วางใจที่จะฟังถึงอารมณ์ลึกๆได้",
      h4: "ควรจะช่วยเขาแยกแยะประเด็นปัญหาที่ยึดว่าเป็นเรื่องเฉพาะตัวและมักจะตำหนิตัวเองและผู้อื่นเพราะเรื่องนั้น",
      h5: "ช่วยประคับประคองในช่วงการปรับตัวกับสถานการณ์ การเปลี่ยนแปลงใหม่ๆ",
    },
    celeb: {
      c1: "เฮอร์ไมโอนี่ เกรนเจอร์",
      c1src:
        "https://static.neris-assets.com/images/personality-types/famous/sentinels_ISTJ_hermione_granger_harry_potter.svg",
      c2: "กัปตันอเมริกา",
      c2src:
        "https://static.neris-assets.com/images/personality-types/famous/sentinels_ISFJ_captain_america.svg",
      c3: "นาตาลี พอร์ตแมน",
      c3src:
        "https://static.neris-assets.com/images/personality-types/famous/sentinels_ISTJ_natalie_portman.svg",
      c4: "จอร์จ วอชิงตัน",
      c4src:
        "https://static.neris-assets.com/images/personality-types/famous/sentinels_ISTJ_george_washington.svg",
    },
  },
  type2: {
    type: "Type2",
    title: "ผู้ให้ (The Giver)",
    description: type2desc,
    strength: {
      s1: "ใส่ใจคนรอบข้าง",
      s2: "ให้ความช่วยเหลือแก่คนอื่น",
      s3: "เข้าใจความรู้สึกคนอื่น",
      s4: "พึ่งพาได้ จัดการเรื่องต่างๆได้ดี",
      s5: "อบอุ่น ใจกว้าง",
    },
    weakness: {
      w1: "ไม่ค่อยมั่นใจในตนเอง",
      w2: "มีการคาดหวังผลตอบแทน แต่ไม่แสดงออกโดยตรง",
      w3: "เอาใจใส่ผู้อื่นตอนตัวเองลำบาก",
      w4: "ไม่กล้าปฏิเสธ",
      w5: "ชอบคิดไปเอง",
    },
    handle: {
      h1: "แสดงถึงความจริงใจให้คนลักษณ์ 2 เห็นและสามารถสัมผัสมันได้",
      h2: "พูดชมเชย ให้กำลังใจ หรือแสดงความคิดเห็นในด้านที่ดี",
      h3: "บอกในสิ่งที่ต้องการจริงๆ เพราะไม่งั้นคนลักษณ์ 2 อาจทำมากกว่านั้น",
      h4: "พูดคุยเล่น เป็นกันเอง สร้างความสบายใจให้กับคนลักษณ์ 2",
      h5: "ยอมรับผลงานและความสำเร็จของคนลักษณ์ 2",
    },
    celeb: {
      c1: "นางฮัดสัน",
      c1src:
        "https://static.neris-assets.com/images/personality-types/famous/sentinels_ESFJ_mrs_hudson_sherlock_holmes.svg",
      c2: "วิล สมิธ",
      c2src:
        "https://static.neris-assets.com/images/personality-types/famous/diplomats_ENFP_will_smith.svg",
      c3: "พีตา เมลลาร์ก",
      c3src:
        "https://static.neris-assets.com/images/personality-types/famous/diplomats_ENFP_peeta_mellark_the_hunger_games.svg",
      c4: "เทย์เลอร์ สวิฟต์",
      c4src:
        "https://static.neris-assets.com/images/personality-types/famous/sentinels_ESFJ_taylor_swift.svg",
    },
  },
  type3: {
    type: "Type3",
    title: "นักแสดง (The Performer)",
    description: type3desc,
    strength: {
      s1: "เชื่อมั่นในตัวเอง",
      s2: "ทะเยอทะยาน",
      s3: "กระฉับกระเฉง",
      s4: "กระตือรือร้น",
      s5: "มีเป้าหมายเป็นสิ่งสำคัญอันดับแรก",
    },
    weakness: {
      w1: "บ้างาน",
      w2: "สนใจเป้าหมายมากเกินไป",
      w3: "อาจลืมสนใจคนรอบตัวที่ทำงานด้วย",
      w4: "ไม่ค่อยมีเวลาให้ใครนอกจากเป้าหมายของตัวเอง",
      w5: "ภาพลักษณ์นั้นสำคัญที่สุด",
    },
    handle: {
      h1: "จำไว้ว่า เขาดูเชื่อมั่น แต่จริงๆแล้วไม่ใช่",
      h2: "อย่าส่งเสริมความสำเร็จของเขาอย่างเดียวโดยยกย่องแต่ผลที่ปรากฏเท่านั้น",
      h3: "สนับสนุนให้เขาสำรวจความเป็นตัวเอง ว่าเขาเป็นใคร",
      h4: "อย่าวิจารณ์หรือโจมตี มันสะเทือนใจและทำให้เขาเคารพตัวเองน้อยลง",
      h5: "ยืนยันที่จะชื่นชมในตัวเขา ไม่ใช่ผลลัพธ์ที่เขาทำ",
    },
    celeb: {
      c1: "บารัค โอบามา",
      c1src:
        "https://static.neris-assets.com/images/personality-types/famous/diplomats_ENFJ_barack_obama.svg",
      c2: "ปอร์ธอส",
      c2src:
        "https://static.neris-assets.com/images/personality-types/famous/sentinels_ESTJ_porthos_the_three_musketeers.svg",
      c3: "บียอนเซ่",
      c3src:
        "https://static.neris-assets.com/images/personality-types/famous/sentinels_ISFJ_beyonce.svg",
      c4: "วิน ดีเซล",
      c4src:
        "https://static.neris-assets.com/images/personality-types/famous/sentinels_ISFJ_vin_diesel.svg",
    },
  },
  type4: {
    type: "Type4",
    title: "คนโศกซึ้ง (The Individualist)",
    description: type4desc,
    strength: {
      s1: "ช่างคิด ช่างจินตนาการ",
      s2: "แคร์ความรู้สึกของผู้อื่น",
      s3: "เป็นตัวของตัวเอง",
      s4: "รับรู้สิ่งต่างๆได้ดี",
      s5: "มีความคิดสร้างสรรค์",
    },
    weakness: {
      w1: "แสดงอารมณ์มากเกินไป",
      w2: "วู่วาม /ขาดการควบคุม",
      w3: "ไม่ยอมรับเหตุผลของคนอื่น",
      w4: "ตัดสินใจด้วยอารมณ์ ทำให้ขาดการตรวจสอบข้อเท็จจริง",
      w5: "ชอบวิพากษ์วิจารณ์",
    },
    handle: {
      h1: "สนับสนุนอุ้มชูให้เขาปฏิบัติในสิ่งที่จะช่วยให้เขาเติบโต",
      h2: "อย่าพยายามช่วยแก้อะไรให้ อย่าแนะนำหรือพยายามช่วยพูดให้เขาเปลี่ยนใจ",
      h3: "เมื่อไม่พอใจเรื่องใด ควรพูดคุยกันดีๆ ค่อยให้เหตุผลตอนอารมณ์สงบ และตรวจสอบว่าเข้าใจผิดหรือไม่",
      h4: "อยู่เคียงข้างเขา รับฟัง ขอเพียงรับรู้และเข้าใจว่าเป็นความจริงที่เขารู้สึกและคิดเช่นนั้น",
      h5: "เห็นคุณค่าของคนลักษณ์ 4 ในเรื่องอุดมคติและความจริงแท้",
    },
    celeb: {
      c1: "วิลลี่ วองก้า",
      c1src:
        "https://static.neris-assets.com/images/personality-types/famous/diplomats_ENFP_willy_wonka_charlie_and_the_chocolate_factory.svg",
      c2: "เลดี้กาก้า",
      c2src:
        "https://static.neris-assets.com/images/personality-types/famous/diplomats_INFJ_lady_gaga.svg",
      c3: "โรส เดวิท บูเคเตอร์",
      c3src:
        "https://static.neris-assets.com/images/personality-types/famous/diplomats_INFJ_rose_dewitt_bukater_titanic.svg",
      c4: "จอน สโนว์",
      c4src:
        "https://static.neris-assets.com/images/personality-types/famous/diplomats_INFJ_jon_snow_game_of_thrones.svg",
    },
  },
  type5: {
    type: "Type5",
    title: "นักสังเกตการณ์ (The Observer)",
    description: type5desc,
    strength: {
      s1: "แยกความคิดจากความรู้สึก เป็นกลาง",
      s2: "วิเคราะห์ได้อย่างดี",
      s3: "บรรลุสัจธรรม และความเป็นจริงของชีวิต",
      s4: "ขี้สงสัย ไม่เชื่ออะไรง่ายๆ",
      s5: "มักพึ่งตัวเอง แก้ไขปัญหาด้วยตัวเอง",
    },
    weakness: {
      w1: "ไม่ผูกพันทางอารมณ์",
      w2: "ขาดความสนใจความรู้สึกผู้อื่น",
      w3: "รักษาระยะห่างจากคนอื่น",
      w4: "ไม่ค่อยเคารพกฎกติกา ไม่ชอบพิธีกรรมที่เสียเวลาไม่มีเหตุผล",
      w5: "เก็บตัวมากเกินไป",
    },
    handle: {
      h1: "หลีกเลี่ยงการใช้อารมณ์ในการแก้ปัญหา",
      h2: "เคารพขอบเขตส่วนตัว",
      h3: "อย่าให้เขาตกเป็นเป้าสายตาใครๆ",
      h4: "ให้ความสำคัญกับข้อเท็จจริง ปรัชญา ความจริง",
      h5: "ส่งเสริมการแสดงความรู้สึก ผ่านสื่ออื่น เช่นการสัมผัส ศิลปะ",
    },
    celeb: {
      c1: "อีลอน มัสก์",
      c1src:
        "https://static.neris-assets.com/images/personality-types/famous/analysts_INTJ_elon_musk.svg",
      c2: "วอลเตอร์ ไวท์",
      c2src:
        "https://static.neris-assets.com/images/personality-types/famous/analysts_INTJ_walter_white_breaking_bad.svg",
      c3: "คริสโตเฟอร์ โนแลน",
      c3src:
        "https://static.neris-assets.com/images/personality-types/famous/analysts_INTJ_christopher_nolan.svg",
      c4: "อัลเบิร์ต ไอน์สไตน์",
      c4src:
        "https://static.neris-assets.com/images/personality-types/famous/analysts_INTP_albert_einstein.svg",
    },
  },
  type6: {
    type: "Type6",
    title: "นักปุจฉา (The Questioner)",
    description: type6desc,
    strength: {
      s1: "คาดการณ์ปัญหาล่วงหน้า",
      s2: "ให้ความร่วมมือที่ดี",
      s3: "ชอบวางแผน",
      s4: "มีความรับผิดชอบ",
      s5: "ขยัน สามารถทำงานหนักได้",
    },
    weakness: {
      w1: "หลงไปกับจินตนาการของตัวเอง",
      w2: "ไม่ไว้ใจผู้มีอำนาจ",
      w3: "มักจำความสำเร็จไม่ได้",
      w4: "มองโลกในแง่ร้าย",
      w5: "ไม่ชอบอะไรที่กำกวมไม่ชัดเจน",
    },
    handle: {
      h1: "ควรสนับสนุนคนลักษณ์ 6 ให้ริเริ่มทำอะไรใหม่ ๆ",
      h2: "ทำให้คนลักษณ์ 6 เห็นว่าโลกนี้มีสิ่งดี ๆ อยู่มาก",
      h3: "ปฎิบัติต่อคนลักษณ์ 6 อย่างเสมอต้นเสมอปลาย",
      h4: "ทำให้คนลักษณ์ 6 นึกถึงความสำเร็จที่เคยเกิด",
      h5: "รับรู้ความกลัวของเขาอย่างจริงจังและค่อยๆช่วยพิเคราะห์ความกลัวนั้น",
    },
    celeb: {
      c1: "เจ อาร์ อาร์ โทลคีน",
      c1src:
        "https://static.neris-assets.com/images/personality-types/famous/diplomats_INFP_j_r_r_tolkien.svg",
      c2: "วิลเลียม เชคสเปียร์",
      c2src:
        "https://static.neris-assets.com/images/personality-types/famous/diplomats_INFP_william_shakespeare.svg?v=5",
      c3: "ดร. วัตสัน",
      c3src:
        "https://static.neris-assets.com/images/personality-types/famous/sentinels_ISFJ_dr_watson_sherlock_holmes.svg",
      c4: "เจสัน บอร์น",
      c4src:
        "https://static.neris-assets.com/images/personality-types/famous/sentinels_ISTJ_jason_bourne_bourne_series.svg",
    },
  },
  type7: {
    type: "Type7",
    title: "คนมองโลกในแง่ดี (The Enthusiast)",
    description: type7desc,
    strength: {
      s1: "จินตนาการและคิดสร้างสรรค์",
      s2: "ร่าเริง คิดเร็ว กระตือรือร้น",
      s3: "ทำงานหลายๆ อย่างในเวลาเดียวกัน",
      s4: "เชื่อมโยงข้อมูลที่กระจัดกระจายให้เข้ากัน",
      s5: "สนใจ เข้ามีส่วนร่วม",
    },
    weakness: {
      w1: "ทำตามแรงกระตุ้นโดยไม่คำนึงถึงผล",
      w2: "ไม่ชัดเจนในเป้าหมาย",
      w3: "เข้าใจความรู้สึกผู้อื่นแต่ไม่สม่ำเสมอ",
      w4: "หาเหตุผลเข้าข้างตนเอง",
      w5: "ไม่ชอบทำอะไรที่ซ้ำซาก",
    },
    handle: {
      h1: "ช่วยเตือนสติเขาว่าตอนนี้เขาขาดอะไรไปบ้างและเขาควรทำอะไร ในเวลาที่เขากำลังสนใจแต่เรื่องที่สนุกสนานเบิกบานใจเพียงอย่างเดียว",
      h2: "ต้องบังคับให้เขาทำสิ่งที่ไม่อยากทำ หรือ ไม่สนุกกับมันบ้าง เพราะจะทำให้เขาได้พัฒนาและเรียนรู้ในหลาย ๆ อย่าง",
      h3: "ทำให้ลักษณ์ 7 เห็นคุณค่าของความรู้สึก ความต้องการ ความคิด ของคนรอบตัวบ้าง",
      h4: "ทำให้เขารู้สึกปลอดภัยที่จะระบายความทุกข์ออกมา",
      h5: "ชี้เมื่อเขากำลังโลดแล่น บางทีเขาเขาอาจกำลังวิ่งหนีอะไรบางอย่าง",
    },
    celeb: {
      c1: "โรเบิร์ต ดาวนีย์ จูเนียร์",
      c1src:
        "https://static.neris-assets.com/images/personality-types/famous/diplomats_ENFP_robert_downey_jr.svg",
      c2: "แจ็ก สแปร์โรว์",
      c2src:
        "https://static.neris-assets.com/images/personality-types/famous/analysts_ENTP_captain_jack_sparrow_pirates_of_the_caribbean.svg",
      c3: "อดัม ซาเวจ",
      c3src:
        "https://static.neris-assets.com/images/personality-types/famous/analysts_ENTP_adam_savage.svg",
      c4: "โรบิน วิลเลียมส์",
      c4src:
        "https://static.neris-assets.com/images/personality-types/famous/diplomats_ENFP_robin_williams.svg",
    },
  },
  type8: {
    type: "Type8",
    title: "เจ้านาย (The Boss)",
    description: type8desc,
    strength: {
      s1: "ตรงไปตรงมา เชื่อมั่นในตนเอง",
      s2: "ชัดเจน ก้าวไปข้างหน้า ไม่ลังเล",
      s3: "กระฉับกระเฉง ทำงานรวดเร็ว",
      s4: "ปกป้องลูกน้อง ทีมงาน เพื่อนผอง",
      s5: "มักจะแก้ปัญหาของกลุ่มเมื่อไม่มีใครทำ",
    },
    weakness: {
      w1: "ใช้อำนาจควบคุมคนอื่น",
      w2: "ไม่ค่อยอดทน หรือหงุดหงิดคนทำงานช้า",
      w3: "หลายครั้งตัดสินใจเร็วเกินไป ขาดการมองอย่างรอบด้าน",
      w4: "คาดหวังสูงทั้งกับตนเองและผู้อื่น",
      w5: "ไม่สอนงานลูกน้อง ถ้าไม่ถาม",
    },
    handle: {
      h1: "ควรพูดอะไร ๆ ตรง ๆ ไม่อ้อมค้อมวกวนกับคนลักษณ์ 8",
      h2: "ให้งานที่ท้าทายความสามารถของคนลักษณ์ 8",
      h3: "ทำอะไรกระชับ กระฉับกระเฉง",
      h4: "แนะนำให้รู็จักการเก็บความรู้สึกของตนอย่างพอเหมาะ",
      h5: "หนุนเกื้อให้เขาปฏิบัติในสิ่งที่ช่วยให้เขาเติบโต",
    },
    celeb: {
      c1: "ซามูเอล แอล แจ็กสัน",
      c1src:
        "https://static.neris-assets.com/images/personality-types/famous/explorers_ESTP_samuel_l_jackson.svg",
      c2: "แฮงก์ ชเรเดอร์",
      c2src:
        "https://static.neris-assets.com/images/personality-types/famous/explorers_ESTP_hank_schrader_breaking_bad.svg?v=5",
      c3: "ร็อคเก็ต แรคคูน",
      c3src:
        "https://static.neris-assets.com/images/personality-types/famous/explorers_ESTP_rocket.svg",
      c4: "กัปตันมาร์เวล",
      c4src:
        "https://static.neris-assets.com/images/personality-types/famous/explorers_ESFP_captain_marvel.svg?v=5",
    },
  },
  type9: {
    type: "Type9",
    title: "ผู้สมานไมตรี (The Peacemaker)",
    description: type9desc,
    strength: {
      s1: "สร้างความสมานฉันท์ในสังคมที่ตนอยู่",
      s2: "มีความเป็นกลาง ไม่ตัดสินคนอื่น",
      s3: "ให้ความสำคัญกับส่วนรวม",
      s4: "เข้ากับคนง่าย",
      s5: "ใจกว้าง",
    },
    weakness: {
      w1: "วอกแวกง่าย",
      w2: "เฉื่อยชา",
      w3: "ไม่ชอบตัดสินใจ",
      w4: "ละเลยคนใกล้ตัว",
      w5: "ดื้อเงียบ",
    },
    handle: {
      h1: "ส่งเสริมคนลักษณ์ 9 ให้ปฏิบัติในสิ่งที่ช่วยให้เขาเติบโต",
      h2: "อย่าบังคับให้เลือกข้าง อย่าทะเลาะกัน",
      h3: "ช่วยคนลักษณ์นี้ให้มีสมาธิจดจ่อ โดยดึงความสนใจกับมาจากเรื่องอื่นๆ แต่ทำอย่างนุ่มนวล",
      h4: "ถามถึงความต้องการที่แท้จริง",
      h5: "สร้างบรรยากาศที่ทำให้คนลักษณ์นี้ได้สำรวจความโกรธของตนเอง",
    },
    celeb: {
      c1: "บรูซ แบนเนอร์ (ฮัลค์)",
      c1src:
        "https://static.neris-assets.com/images/personality-types/famous/analysts_INTP_bruce_banner.svg",
      c2: "แฮร์ริสัน ฟอร์ด",
      c2src:
        "https://static.neris-assets.com/images/personality-types/famous/analysts_ENTJ_harrison_ford.svg",
      c3: "เคทลิน สตาร์ค",
      c3src:
        "https://static.neris-assets.com/images/personality-types/famous/sentinels_ISFJ_catelyn_stark_game_of_thrones.svg",
      c4: "แคเธอริน เอลิซาเบธ มิดเดิลตัน",
      c4src:
        "https://static.neris-assets.com/images/personality-types/famous/sentinels_ISFJ_kate_middleton.svg",
    },
  },
};

export const stereotype = [
  // 0
  "นพลักษณ์คืออะไร?",
  // 1
  "นพลักษณ์ (Enneagram) เป็นศาสตร์องค์ความรู้โบราณระบบหนึ่ง ที่เกิดขึ้นแถบเอเชียกลางมานานนับสหัสวรรษ โดยอาจารย์กลุ่มซูฟี ซึ่งเป็นนักภาวนาในศาสนาอิสลาม",
  // 2
  "นพลักษณ์ เชื่อว่าคนถูกแบ่งออกเป็น 9 ลักษณ์ ทุกคนแตกต่างกัน มีจุดด้อยจุดแข็งที่ต่างกัน ไม่มีลักษณ์ไหนแย่ไปกว่าลักษณ์ไหน ",
  // 3
  "ในอินเตอร์เน็ตมีแบบทดสอบนพลักษณ์มากมาย ทั้งแบบสั้นและแบบยาว ซึ่งอาจไม่ได้แม่นยำนัก สิ่งที่พวกเราแนะนำคือการหาหนังสือ บทความ ค่อย ๆ อ่านและทำความเข้าใจข้อมูลชุดนั้น ทำความเข้าใจตัวเองอย่างลึกซึ้ง ลองคุยกับผู้คนแต่ละลักษณ์ หรือลองหาคอร์สเรียนนพลักษณ์ เพื่อช่วยให้เราค้นหาลักษณ์ได้ง่ายขึ้น",
  // 4
  "แม้อาจจะพอคาดเดาลักษณ์ได้จากพฤติกรรมหรืออุปนิสัย ในแต่ละช่วงชีวิตพฤติกรรมและนิสัยของเราอาจเปลี่ยนไปได้ จนทำให้เราคิดว่าเราเองก็อาจมีหลายลักษณ์  แต่แท้จริงแล้วลักษณ์ถูกแบ่งตามแรงขับเคลื่อนกิเลสที่อยู่ภายในซึ่งติดตัวเรามาตั้งแต่เกิด",
  // 5
  "เป็นเรื่องยากที่เราจะสามารถฟันธงได้ว่าใครเป็นลักษณ์ไหน แม้กระทั่งผู้เชี่ยวชาญเองก็ตาม เพราะมันเป็นเรื่องที่อยู่ภายใน เป็นเหมือนเหตุผลในการกระทำของเราซึ่งมีเพียงเราเท่านั้นที่จะสามารถบอกได้ ว่าตัวเองเป็นลักษณ์อะไร นพลักษณ์จึงเป็นอีกหนึ่งเครื่องมือที่ดีในการช่วยให้เรารู้จักตัวเองในเบื้องลึกขึ้น",

  // 6
  "แล้วเราเรียนไปเพื่ออะไร?",
  // 7
  "นพลักษณ์ช่วยให้เราเข้าใจตัวเองมากขึ้น และได้รู้จักกับกิเลสที่อยู่ในใจลึก ๆ ของเรา บางทีเราอาจจะไม่รู้ตัวว่าเราเป็นแบบไหน แต่การเรียนนพลักษณ์จะช่วยให้เราได้สังเกตตัวเองมากขึ้น ได้รู้ว่าตัวเองมีจุดเด่นจุดด้อยยังไง เพื่อที่จะได้ปรับปรุงแก้ไขและดึงศักยภาพของตัวเองออกมาให้เต็มที่ ",
  // 8
  "นอกจากเข้าใจตัวเองแล้วก็ยังช่วยให้เราเข้าใจผู้อื่นมากขึ้นด้วย เพราะนพลักษณ์ทำให้เราเห็นถึงความแตกต่างของคน ได้รู้ว่าแต่ละคนก็ให้ค่าและความสำคัญกับแต่ละเรื่องไม่เท่ากัน แต่เราต้องไม่ใช้ลักษณ์ในการตัดสินคนอื่น หรือเอาไปใช้ตำหนิใคร ๆ ว่าเพราะเขาเป็นลักษณ์นี้จึงได้นิสัยแบบนี้ โดยที่เราต้องเรียนรู้และทำความเข้าใจเพื่อที่จะอยู่ร่วมกัน",
  // 9
  "และสิ่งสำคัญที่สุดก็คือ “เรารู้ลักษณ์เพื่อจะออกจากของลักษณ์ตัวเอง” ไม่ใช่รู้ว่าตัวเองเป็นแบบไหนแล้วยึดว่าจะต้องเป็นแบบนั้นไปตลอด เพราะทุก ๆ คนก็ต้องมีการพัฒนา ถ้ารู้ว่านิสัยไหนของตัวเองไม่ดีก็พยายามลดละออกไป แล้วไปเพิ่มสิ่งดี ๆ ที่ตัวเองยังขาดอยู่เข้ามาให้ได้",
];

export const cardDesc = {
  cardA: [
    "ฉันสัมพันธ์กับสิ่งต่างๆ ในแบบที่ต้องได้ทั้งหมดหรือไม่ก็ไม่เอาสักอย่างเลย โดยเฉพาะในเรื่องที่สำคัญต่อตัวฉัน",
    "ฉันให้คุณค่ามากกับการเป็นคนเข้มแข็ง ซื่อสัตย์ และพึ่งพาได้",
    "ฉันรู้สึกลำบากมากที่ต้องอดทนกับความอ่อนแอของคนอื่น ยกเว้นว่าเขากำลังพยายามแก้ไขอยู่",
    "การทำตามคำสั่งหรือระเบียบที่วางไว้ก็เป็นเรื่องยากสำหรับฉันหากฉันไม่เคารพหรือไม่เห็นด้วยกับผู้ที่มีอำนาจ",
    "ฉันชอบเป็นนายตนเองมากกว่า ฉันเป็นหรือคิดอย่างไรก็แสดงออกมาอย่างนั้น ไม่มีการเสแสร้ง",
    "ฉันจะยังไม่เชื่อใจใครจนกว่าเขาจะพิสูจน์ตนเองได้ว่าไว้วางใจได้",
    "ฉันชอบคนตรงไปตรงมากับฉัน และฉันรู้เสมอถ้ามีใครกำลังเล่นไม่ซื่อ โกหก หรือพยายามหลอกลวงฉัน",
    "ฉันพบว่าเป็นเรื่องยากที่จะไม่แสดงความรู้สึกออกมาเวลาโกรธ",
    "ฉันพร้อมที่จะอยู่เคียงข้างกับเพื่อนๆ หรือคนรัก โดยเฉพาะอย่างยิ่งเวลาพวกเขาถูกเอาเปรียบ",
    "ฉันอาจจะไม่ชนะทุกครั้งในการรบกับคนอื่นแต่พวกเขาจะรู้ว่าฉันยังอยู่ตรงนั้น",
  ],
  cardB: [
    "ฉันมีมาตรฐานภายในสูงมากในเรื่องความถูกต้อง และฉันคาดหวังให้ตนเองทำให้ได้ตามมาตรฐานนั้น",
    "เป็นเรื่องง่ายสำหรับฉันที่จะมองเห็นข้อผิดพลาดในสิ่งต่าง ๆ ที่เป็นอยู่",
    "ฉันคิดเสมอว่าจะแก้ไขหรือจะมีวิธีอย่างไรที่จะทำให้ได้ผลดีขึ้นอีก",
    "และลงมือทำทุกครั้งที่เป็นไปได้ฉันอาจจะดูเหมือนคนที่ช่างวิพากษ์วิจารณ์ หรือต้องการความสมบูรณ์แบบ",
    "เป็นเรื่องยากทีเดียวที่ฉันจะละเลยหรือยอมรับสิ่งที่ทำอย่างไม่ถูกต้อง",
    "บางครั้งฉันฉันรู้สึกขุ่นเคืองใจเวลาที่คนอื่นเลือกที่จะมองข้ามหรือไม่พยายามทำอะไรให้ถูก หรือแสดงความไม่รับผิดชอบ ความไม่เป็นธรรม",
    "คนอื่นอาจสังเกตเห็นความผิดปกติจากฉันได้แม้ว่าฉันจะพยายามไม่แสดงออกอย่างเปิดเผยแล้วก็ตาม",
    "ฉันรู้สึกภาคภูมิใจในตัวเอง ว่าถ้าฉันรับผิดชอบทำอะไรแล้ว มั่นใจได้เลยว่าฉันจะทำสิ่งนั้นอย่างถูกต้อง",
    "สำหรับฉันแล้วงานต้องมาก่อนความสบายความถูกต้อง ต้องมาก่อนความภูมิใจ",
    "และฉันต้องเก็บกดความต้องการของตัวเองเอาไว้เพราะจำเป็นต้องให้งานที่รับผิดชอบเสร็จเรียบร้อยก่อน",
  ],
  cardC: [
    "ดูเหมือนว่าฉันจะสามารถมองเห็นทุก ๆ แง่มุมได้ง่ายมาก",
    "หลายครั้งฉันอาจจะดูเป็นคนตัดสินใจไม่ได้ เพราะฉันเห็นข้อดีและและข้อเสียของทุกเรื่อง",
    "ความสามารถในการมองเห็นทุกด้านนี้เอง ที่ทำให้ฉันถนัดในการช่วยให้คนอื่น ๆ อยู่ร่วมกันได้",
    "และบางครั้งทำให้ฉันเข้าใจสถานะ ความต้องการและสิ่งที่สำคัญในชีวิตส่วนตัวของคนอื่นดีกว่าของตัวเองเสียอีก",
    "ไม่แปลกที่ฉันถูกสิ่งต่าง ๆ รอบตัวเบี่ยงเบนความสนใจ และละจากหน้าที่ในงานสำคัญ ๆที่กำลังทำอยู่",
    "เมื่อเกิดเหตุการณ์เช่นนี้ขึ้นฉันมักหันเหไปสนใจงานเล็กๆ ที่ไม่สลักสำคัญเท่าไหร่",
    "มันเป็นเรื่องยากที่จะรู้ว่าอะไรสำคัญสำหรับฉันจริง ๆ",
    "ฉันมักจะหลีกเลี่ยงความขัดแย้ง ด้วยการทำในสิ่งที่คนอื่นต้องการให้ทำ",
    "ผู้คนมักมองว่าฉันเป็นคนง่าย ๆ ใจดี และเห็นด้วยไปหมด  จึงเป็นเรื่องยากที่ในการที่จะทำให้ฉันโกรธจนถึงจุดที่จะต้องแสดงออกกับใครตรง ๆ",
    "ฉันชอบวิธีที่สบาย ๆ กลมกลืน และเป็นที่ยอมรับของคนอื่น ๆ",
  ],
  cardD: [
    "ฉันรู้สึกอ่อนไหวกับความรู้สึกของคนอื่น",
    "ฉันสามารถรู้ได้ว่าคนอื่นต้องการอะไร แม้แต่คนที่ฉันไม่รู้จัก",
    "บางครั้งก็น่าอึดอัด ที่รู้ชัดถึงความต้องการของคนอื่น โดยเฉพาะความเจ็บปวด และความทุกข์ของพวกเข้า เพราะฉันไม่สามารถที่จะทำอะไรให้พวกเขาได้มากอย่างที่ฉันต้องการ",
    "สำหรับฉันความสัมพันธ์ที่ดีนั้นมีความหมายมาก และฉันเต็มใจที่จะทุ่มเทเพื่อให้ความสัมพันธ์ที่ดีนั้นเกิดขึ้น",
    "มันเป็นเรื่องง่ายสำหรับฉันที่จะเสียสละตนเอง",
    "บางครั้งฉันก็อยากหัดปฏิเสธให้เป็น เพราะฉันมักลงเอยด้วยการทุ่มเทพลังไปกับการดูแลคนอื่น มากกว่าการดูแลตัวเอง",
    "ฉันรู้สึกเสียใจถ้าคนอื่นคิดว่าฉันกำลังพยายามจัดการ หรือ ควบคุมคนอื่นทั้ง ๆที่ฉันเพียงแต่ทำความเข้าใจและช่วยเหลือพวกเขา",
    "ฉันอยากถูกมองว่าเป็นคนอบอุ่น และเป็นคนดี",
    "แต่เวลาที่ฉันไม่ได้รับความสนใจ หรือไม่เป็นที่ชื่นชม ฉันจะกลายเป็นคนเจ้าอารมณ์ ไปจนถึงเป็นคนเจ้ากี้เจ้าการที่เรียกร้องมาก ",
  ],
  cardE: [
    "ฉันต้องการเป็นคนเลิศในทุกสิ่งที่ฉันทำหลายปีที่ผ่านมา ฉันได้รับการยอมรับนับถืออย่างมากในด้านความสำเร็จ",
    "ฉันได้ทำสิ่งต่าง ๆ มากมาย และสำเร็จลุล่วงเกือบทุกอย่าง",
    "ฉันให้ความสำคัญกับงาน และกิจกรรมที่ฉันทำอย่างมาก เพราะโดยรวมแล้วฉันคิดว่าคุณค่าของคนอยู่ที่ทำได้สำเร็จ และได้รับการยอมรับจากความสำเร็จนั้น",
    "ฉันมักจะมีอะไร ๆ ที่ต้องทำมากกว่าเวลาที่มีอยู่ ดังนั้น ฉันจึงต้องตัดเรื่องความรู้สึก และการพิจารณาไตร่ตรองตนเองออกไปก่อน เพื่อที่จะได้ทำสิ่งต่าง ๆ ได้เสร็จ",
    "การที่มีอะไรที่ต้องทำเสมอทำให้เป็นเรื่องยากที่จะนั่งเฉย ๆ",
    "ฉันทนไม่ได้กับคนที่ทำให้ฉันเสียเวลาโดยใช่เหตุ",
    "บางครั้งฉันมักเข้าไปจัดการงานต่าง ๆ แทนคนอื่นที่ทำเสร็จช้ามาก",
    "ฉันชอบ และอยากให้เห็นว่า ฉันเหนือกว่าคนอื่นในทุกสถานการณ์",
    "ฉันชอบแข่งขัน ขณะเดียวกันฉันก็เป็นผู้ร่วมทีมที่ดีด้วย",
  ],
  cardF: [
    "ฉันมองว่าตนเองเป็นคนเงียบ ๆ และช่างคิดวิเคราะห์ ซึ่งต้องการเวลาอยู่เพียงลำพัง และทำอะไรด้วยตนเองมากกว่าคนอื่นส่วนใหญ่",
    "ฉันมักจะชอบสังเกตสิ่งที่เกิดขึ้นมากกว่าที่จะเข้าไปเกี่ยวข้องด้วย",
    "ฉันไม่ชอบภาวะที่มีคนเรียกร้อง และวุ่นวายกับชีวิตส่วนตัวของฉัน หรือคาดหวังให้ฉันรู้ และบอกสิ่งที่ฉันรู้สึก",
    "ฉันสามารถเข้าถึงความรู้สึกของตนเองได้ดี เวลาที่ฉันอยู่ตามลำพังมากกว่าเวลาที่อยู่กับคนอื่น และบ่อยครั้งที่ฉันพอใจรื้อฟื้นความรู้สึกเหล่านั้นขึ้นมาใคร่ครวญ ทบทวน มากกว่าที่จะเผชิญหน้ากับความรู้สึกนั้นจริง ๆ เสียอีก",
    "ฉันแทบไม่เคยรู้สึกเบื่อหน่ายเลยเวลาที่ได้อยู่คนเดียว เพราะว่าฉันมีชีวิตจิตใจที่ตื่นตัวอยู่ภายใน",
    "เป็นเรืองสำคัญมากสำหรับฉันที่ต้องปกป้องเวลา และพลังงานของฉัน เพื่อที่จะได้ใช้ชีวิตอย่างเรียบง่าย ไม่ซับซ้อน และพึ่งตนเองได้มากที่สุด เท่าที่จะทำได้",
  ],
  cardG: [
    "ฉันมีจินตนาการที่แจ่มชัด โดยเฉพาะเมื่อสิ่งที่เข้ามาอาจจะคุกคามความปลอดภัย และความมั่นคง",
    "ฉันมักจะบอกได้ว่าอะไรที่อาจเป็นอันตรายหรือเสี่ยงภัยและอาจสัมผัสรับรู้ความกลัวนั้นได้มากราวกับกำลังเกิดขึ้นจริง",
    "บ่อยครั้งที่ถ้าไม่หลีกเลี่ยงอันตรายก็เดินหน้าชนไปเลย",
    "นอกจากนี้จินตนาการของฉันยังนำไปสู่การคิดค้นและอารมณ์ขันที่คาดไม่ถึงเลยทีเดียว",
    "ฉันชอบมีชีวิตที่ชัดเจนแน่นอน อย่างไรก็ดี",
    "โดยทั่วไปแล้วฉันมักจะไม่ไว้ใจผู้คนและสิ่งต่าง ๆ รอบตัว",
    "ฉันมักจะเห็นข้อบกพร่องในความคิดเห็นของคนอื่น ดังนั้นฉันคิดว่าคนอื่นอาจจะมองว่าฉันฉลาดมีไหวพริบ",
    "ฉันมีแนวโน้มที่จะตั้งข้อสงสัยต่ออำนาจและไม่สบายใจมากกับการถูกมองว่าเป็นผู้มีอำนาจการที่ฉันสามารถมองเห็นได้ว่าความคิดที่ยึดถือกันทั่วๆไปนั้นมีอะไรผิดปกติ ฉันจึงมีแนวโน้มที่จะเป็นพวกเดียวกับผู้ที่ด้อยกว่า",
    "เมื่อใดที่ฉันอุทิศตนให้ใคร หรืออุดมการณ์อะไรแล้ว ฉันก็จงรักภักดีกับคนหรือสิ่งนั้น",
  ],
  cardH: [
    "ฉันเป็นคนมองโลกในแง่ดี และสนุกกับสิ่งน่าสนใจใหม่ ๆ ที่ผ่านเข้ามา ",
    "สมองของฉันตื่นตัวมาก และคิดเรื่องต่าง  ๆ กลับไปกลับมาอย่างรวดเร็ว",
    "ฉันชอบประสานความคิดต่าง ๆ เหล่านี้เข้าด้วยกันเป็นภาพรวมทั้งหมด และรู้สึกตื่นเต้นเวลาเชื่องโยงความคิด ที่ตอนแรกดูเหมือนจะไม่เกี่ยวข้องกัน",
    "ฉันชอบทำงานที่ตนเองสนใจ และมีพลังมากมายอุทิศให้ ",
    "ฉันเบื่อการจมอยู่กับงานที่ซ้ำซาก และไม่เห็นผล",
    "ฉันชอบอยู่ในช่วงเริ่มต้นโครงงานในชั้นวางแผน เพราะเป็นเวลาที่อาจจะได้พิจารณาทางเลือกที่น่าสนใจ",
    "เวลาที่ฉันหมดความสนใจกับบางสิ่ง ก็เป็นเรื่องยากที่จะทนอยู่ต่อไป เพราะฉันอยากจะเปลี่ยนไปทำเรื่องอื่นที่ดึงดูดความสนใจ",
    "ถ้ามีอะไรมาทำให้ฉันรู้สึกท้อแท้ ฉันก็จะหันไปสนใจความคิดอื่นที่น่าพึงใจมากกว่า",
    "ฉันเชื่อว่าคนเราสมควรมีชีวิตที่น่ารื่นรมย์",
  ],
  cardI: [
    "ฉันเป็นคนอ่อนไหวและเต็มเปี่ยมไปด้วยความรู้สึกบ่อยครั้งที่ฉันรู้สึกโดดเดี่ยว ไม่มีใครเข้าใจเพราะฉันช่างแตกต่างจากคนอื่น",
    "คนอื่นมักมองว่าฉันอ่อนไหวเกินไปและท่วมท้นทางความรู้สึก",
    "ฉันสามารถสัมผัสได้ถึงความงดงามอันละเอียดอ่อนในโลกที่เต็มไปด้วยความรู้สึก และความหมาย",
    "ความปรารถนาที่แท้จริงจากส่วนลึกในจิตใจของฉันคือ สัมพันธภาพที่ลึกซึ้งและเป็นดั่งสายใยเชื่อมโยงกันทางความรู้สึก",
    "ฉันไขว่คว้าหาสายใยทางอารมณ์ความรู้สึกมาชั่วชีวิต ความไร้เยื่อใย ทำให้ฉันทุกข์ตรม และเศร้าหมอง",
    "อย่างไรก็ดี ฉันมักจะไม่ซาบซึ่งกับสัมพันธภาพที่มีอยู่ในปัจจุบัน เพราะฉันมักจะโหยหาในสิ่งที่ฉันขาดหาย และไม่เห็นค่าของสิ่งที่ฉันมีอยู่",
    "บางครั้งฉันก็แปลกใจว่า ทำไมคนอื่นถึงมีสัมพันธภาพที่ดีกว่าฉันมีชีวิตที่มีความสุขกว่าฉัน",
  ],
};
